import React, {Component} from 'react';
import './App.css'
 class App extends Component {
currentTime(){
  return new Date();
};
constructor(props) {
    super(props);
      this.state = {
      birthDay : new Date(localStorage.getItem('dob')) || undefined ,
      time : this.currentTime(),
      age : undefined,
    };
    this.handleChange = this.handleChange.bind(this);
  }
 handleChange(e){
   this.setState({birthDay:new Date(e.target.value)})
   localStorage.setItem('dob',e.target.value)
 }
   
render() {
let years = this.state.age / 31556900000
let majorminor=years.toFixed(9).toString().split('.');

  return ( 
  <div className = "App" >
    <p>Birthdate:{localStorage.getItem('dob')}</p> 
    <input type ='date'  onChange={this.handleChange}/>
      <h1>{majorminor[0]}<span>.{majorminor[1]}</span></h1>
  </div>
  );
}
componentDidMount(){
  this.interval = setInterval(()=>
  {this.setState({age:this.currentTime()-this.state.birthDay})}
    ,100)
}
componentWillUnmount(){
  clearInterval(this.interval)
}
}

export default App;